<template>
  <v-layout align-center class="py-2" style="height: 52px">
    <v-tooltip bottom color="primary" open-delay="100">
      <template v-slot:activator="{ on }">
        <img src="@/assets/logos/WEEZIE_logo_PNI.png" class="back-button" @click="backToHub" />
      </template>
      <span style="font-size: 9px">{{ $t("BackToHub") }}</span>
    </v-tooltip>
  </v-layout>
</template>

<script>

export default {
  name: "Title",

  components: {  },

  methods: {
    /**
     * Back To Hub
     * @returns {Promise<void>}
     */
    async backToHub() {
      await this.$router.push({ name: "hub" });
    }
  }
};
</script>

<style scoped>
.back-button {
  width: 300px;
  cursor: pointer;
  margin-left: -25px;
}

.title-sidebar {
  font-weight: bold;
  padding: 15px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/LeftSidebar/Title.vue